import { Preferences } from '@capacitor/preferences';

export default class Storage {
    constructor(options) {
    }
    async load(key) {
        let data = null;
        let dataRaw = localStorage?.getItem?.(key);

        if (dataRaw === null) {
            const { value } = await Preferences.get({ key });
            dataRaw = value;
        }

        if (dataRaw !== null && dataRaw != "{}") {
            try {
                data = JSON.parse(dataRaw);
            } catch (e) {
                data = null; //error in the above string(in this case,yes)!
            };
        }

        return data;
    }
    async save(key, data) {
        var jsonData = JSON.stringify(data);
        try {
            localStorage[key] = jsonData;
        } catch (e) {
            console.warn("save: " + e);
        }
         //save to local file
        await Preferences.set({ key, value: jsonData });
    }
}